"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx as cn } from "@/helpers/clsx";
import { AnimatePresence, motion } from "framer-motion";
import React, { useState } from "react";
export const FlipWords = t0 => {
  const $ = _c(26);
  const {
    words,
    duration: t1,
    className,
    children
  } = t0;
  const duration = t1 === undefined ? 5000 : t1;
  const [currentWord, setCurrentWord] = useState(words[0]);
  useState(false);
  let t2;
  if ($[0] !== words) {
    t2 = words.join("");
    $[0] = words;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const wordString = t2;
  let t3;
  if ($[2] !== duration || $[3] !== words) {
    t3 = () => {
      const interval = setInterval(() => {
        setCurrentWord(currentWord_0 => words[words.indexOf(currentWord_0) + 1] || words[0]);
      }, duration);
      return () => clearInterval(interval);
    };
    $[2] = duration;
    $[3] = words;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== duration || $[6] !== wordString) {
    t4 = [duration, wordString];
    $[5] = duration;
    $[6] = wordString;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  React.useEffect(t3, t4);
  Array.isArray(children) ? children.join("") : children;
  let t5;
  if ($[8] !== children) {
    t5 = <motion.span>{children}</motion.span>;
    $[8] = children;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  let t7;
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      opacity: 0,
      y: 10
    };
    t7 = {
      opacity: 1,
      y: 0
    };
    t8 = {
      duration: 0.4,
      ease: "easeInOut",
      type: "keyframes",
      stiffness: 100,
      damping: 10
    };
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] !== className) {
    t9 = cn("relative z-10 inline-block text-left", className);
    $[13] = className;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== currentWord) {
    t10 = currentWord.split("").map((letter, index) => <motion.span key={currentWord + index} initial={{
      opacity: 0,
      y: 10,
      filter: "blur(8px)",
      z: 0.0001
    }} animate={{
      opacity: 1,
      y: 0,
      filter: "blur(0px)",
      z: 0.0001
    }} transition={{
      delay: index * 0.08,
      duration: 0.4,
      type: "keyframes"
    }} className="inline-block">{letter}</motion.span>);
    $[15] = currentWord;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t9) {
    t11 = <motion.div initial={t6} animate={t7} transition={t8} className={t9} aria-hidden="true">{t10}</motion.div>;
    $[17] = t10;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== currentWord || $[21] !== t11) {
    t12 = <AnimatePresence key={currentWord}>{t11}</AnimatePresence>;
    $[20] = currentWord;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t5) {
    t13 = <>{t5}{t12}</>;
    $[23] = t12;
    $[24] = t5;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  return t13;
};